import { module } from 'modujs'
import { createApp, ref, reactive } from 'vue/dist/vue.esm-bundler.js'
import useVuelidate from "@vuelidate/core"
import { ENV, VUE_SETTINGS } from '../config'

export default class extends module {
    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el

        // Default vars
        this.components = {}
        this.rules = {}
        this.endpoint = ''
    }

    init() {

        const RECAPTCHA_SITE_KEY = '6LcuS6wpAAAAANlbJuiyr0g0_dVsrkiabq6WQVXP'

        // Define submission messages
        this.submission = Object.assign({
            success: 'Success',
            error: 'An error occured, lease try again.',
        }, this.submission)

        this.vueApp = createApp({
            ...VUE_SETTINGS,
            components: this.components,
            setup: () => {

                // Vars
                const submissionMessage = ref(null)

                // Vuelidate
                const state = reactive(Object.keys(this.rules).reduce((k, v) => (k[v] = null, k), {}))
                const v$ = useVuelidate(this.rules, state)

                // Methods
                const submit = () => {

                    if(v$.value.$invalid) {
                        return
                    }

                    grecaptcha.ready(() => {
                        grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'submit'}).then(token => {

                            const data = new FormData()
                            data.append('token', token)
                            for(let item in state) {
                                data.append(item, state[item])
                            }

                            fetch(this.endpoint, {
                                method: 'POST',
                                body: data,
                            })
                            .then(e => {
                                if (ENV.IS_DEV) {
                                    console.log(e)
                                }
                                submissionMessage.value = this.submission.success
                                setTimeout(() => {
                                    // Reset fields
                                    for(let item of Object.keys(state)) {
                                        v$.value[item].$model = null
                                    }
                                    v$.value.$reset()

                                    // Remove message
                                    submissionMessage.value = null
                                }, 5000);
                            })
                            .catch(e => {
                                if (ENV.IS_DEV) {
                                    console.log(e)
                                }
                                submissionMessage.value = this.submission.error
                                setTimeout(() => {
                                    // Remove message
                                    submissionMessage.value = null
                                }, 5000);
                            })
                        })
                    })
                }

                return {
                    submissionMessage,
                    v$,
                    submit,
                }
            }
        })
        this.vueApp.mount(this.$el)
    }

    destroy() {
        this.vueApp?.unmount()
    }
}
